import type * as api from '@gitbook/api-client';
import type { NavigationShareSideSheet } from '@gitbook/app-navigation';
import { DialogRoot } from '@gitbook/spine-react';
import { useEventCallback } from '@gitbook/util-react-hooks';

import { InviteMembersDialog } from '../../../Components';
import { useNavigation, useSideSheetNavigation } from '../../../navigation';

function useShareModalState() {
    const state = useSideSheetNavigation<NavigationShareSideSheet>('share');
    const setOpen = useToggleShareModal('invite');
    return [state.selectedTab === 'invite' && state.opened, setOpen] as const;
}

/**
 * Button to open the share modal for a space.
 */
export function SpaceShareDialog(props: { space: api.Space }) {
    const { space } = props;
    const [opened, setOpen] = useShareModalState();

    return (
        <DialogRoot isOpen={opened} onOpenChange={setOpen} key={space.id}>
            <InviteMembersDialog content={{ space }} />
        </DialogRoot>
    );
}

export function useToggleShareModal(tab: NavigationShareSideSheet['tab']) {
    const { navigate } = useNavigation();

    return useEventCallback((open: boolean) => {
        navigate(
            {
                screen: {
                    sideSheet: open ? { type: 'share', tab } : undefined,
                },
            },
            { replace: true }
        );
    });
}
